import { Tabs, type TabItem, type TabsProps } from './Tabs'

export type SubTabItem = TabItem
export type SubTabsProps = Omit<TabsProps, 'variant'>

/** Pill appearance of the shared, owner-controlled tab engine. */
export function SubTabs(props: SubTabsProps) {
  return <Tabs {...props} variant="sub" />
}
